export function applyConditionStageUpdate(token, stageUpdate, mergedUpdate) {
  if (Array.isArray(stageUpdate?.conditions)) {
    mergedUpdate.conditions = Array.from(new Set([
      ...(Array.isArray(token?.conditions) ? token.conditions : []),
      ...stageUpdate.conditions.filter(Boolean)
    ]));
  }

  if (Array.isArray(stageUpdate?.conditionsToRemove)) {
    const removals = new Set(stageUpdate.conditionsToRemove.map((condition) => (
      String(condition || '').trim().toLowerCase()
    )));
    mergedUpdate.conditions = (Array.isArray(mergedUpdate.conditions)
      ? mergedUpdate.conditions
      : (Array.isArray(token?.conditions) ? token.conditions : [])
    ).filter((condition) => !removals.has(String(condition || '').trim().toLowerCase()));
  }

  delete mergedUpdate.conditionsToRemove;
  return mergedUpdate;
}
